var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _path5, _path6, _circle, _path7, _circle2, _path8, _circle3, _path9, _circle4, _path0, _circle5, _path1, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8LiechtensteinCircular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M23.989,44c11.046,0,20-8.954,20-20h-40C3.989,35.046,12.944,44,23.989,44z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#283593",
    d: "M23.989,4c-11.046,0-20,8.954-20,20h40C43.989,12.954,35.035,4,23.989,4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdd835",
    d: "M18.799,13.481c0,0-4.962-1.5-6-0.462s0.323,5.216,0.323,5.216l5.331,0.162L18.799,13.481z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M18.5,18.448l-0.049-0.002l-5.366-0.162l-0.011-0.033c-0.056-0.172-1.358-4.219-0.311-5.267 c1.047-1.05,5.847,0.387,6.051,0.448l0.038,0.012l-0.003,0.04L18.5,18.448z M13.159,18.187l5.247,0.158l0.341-4.828 c-0.464-0.135-4.955-1.422-5.913-0.462C11.878,14.012,13.034,17.79,13.159,18.187z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 0.1,
    height: 5.101,
    x: 17.001,
    y: 12.81,
    fill: "#231f20"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 0.1,
    height: 5.101,
    x: 17.392,
    y: 12.81,
    fill: "#231f20"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 0.1,
    height: 4.274,
    x: 13.083,
    y: 13.097,
    fill: "#231f20"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 0.1,
    height: 5.101,
    x: 13.482,
    y: 12.81,
    fill: "#231f20"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 0.1,
    height: 5.101,
    x: 13.873,
    y: 12.81,
    fill: "#231f20"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 0.1,
    height: 5.101,
    x: 14.265,
    y: 12.81,
    fill: "#231f20"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 0.1,
    height: 5.101,
    x: 14.655,
    y: 12.81,
    fill: "#231f20"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 0.1,
    height: 5.101,
    x: 15.046,
    y: 12.81,
    fill: "#231f20"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 0.1,
    height: 5.101,
    x: 15.438,
    y: 12.81,
    fill: "#231f20"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 0.1,
    height: 5.101,
    x: 15.828,
    y: 12.81,
    fill: "#231f20"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 0.1,
    height: 5.101,
    x: 16.219,
    y: 12.81,
    fill: "#231f20"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 0.1,
    height: 5.101,
    x: 16.61,
    y: 12.81,
    fill: "#231f20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdd835",
    d: "M17.899,13.665c0,0-3.323-1.246-4.708-0.462c-1.385,0.785,0.162,4.039,0.162,4.039l-1.062-0.369 c0,0-1.168-3.017,0.646-4.154c1.546-0.969,5.077,0.438,5.077,0.438L17.899,13.665z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M13.449,17.329l-1.196-0.416l-0.009-0.022c-0.012-0.03-1.161-3.068,0.667-4.214 c1.551-0.973,4.977,0.376,5.122,0.434l0.04,0.017l-0.138,0.605l-0.054-0.021c-0.033-0.014-3.316-1.229-4.666-0.464 c-1.329,0.752,0.167,3.94,0.182,3.973L13.449,17.329z M12.33,16.834l0.928,0.322c-0.26-0.582-1.373-3.27-0.091-3.996 c1.309-0.742,4.246,0.275,4.696,0.438l0.093-0.41c-0.393-0.15-3.572-1.317-4.992-0.428C11.284,13.814,12.23,16.562,12.33,16.834z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.607,
    cy: 15.878,
    r: 0.424,
    fill: "#fdd835"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M11.607,16.352c-0.262,0-0.474-0.212-0.474-0.474s0.212-0.474,0.474-0.474 s0.474,0.212,0.474,0.474S11.869,16.352,11.607,16.352z M11.607,15.504c-0.206,0-0.374,0.168-0.374,0.374 s0.168,0.374,0.374,0.374s0.374-0.168,0.374-0.374S11.813,15.504,11.607,15.504z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.265,
    cy: 12.719,
    r: 0.424,
    fill: "#fdd835"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M12.266,13.193c-0.262,0-0.475-0.213-0.475-0.475s0.213-0.474,0.475-0.474 s0.474,0.212,0.474,0.474S12.527,13.193,12.266,13.193z M12.266,12.345c-0.207,0-0.375,0.168-0.375,0.374 c0,0.207,0.168,0.375,0.375,0.375c0.206,0,0.374-0.168,0.374-0.375C12.64,12.513,12.472,12.345,12.266,12.345z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.763,
    cy: 13.437,
    r: 0.424,
    fill: "#fdd835"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M11.764,13.911c-0.262,0-0.475-0.212-0.475-0.474s0.213-0.474,0.475-0.474 s0.474,0.212,0.474,0.474S12.025,13.911,11.764,13.911z M11.764,13.063c-0.207,0-0.375,0.168-0.375,0.374 s0.168,0.374,0.375,0.374c0.206,0,0.374-0.168,0.374-0.374S11.97,13.063,11.764,13.063z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.538,
    cy: 14.251,
    r: 0.424,
    fill: "#fdd835"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M11.538,14.725c-0.262,0-0.474-0.212-0.474-0.474s0.212-0.474,0.474-0.474 s0.474,0.212,0.474,0.474S11.8,14.725,11.538,14.725z M11.538,13.877c-0.206,0-0.374,0.168-0.374,0.374s0.168,0.374,0.374,0.374 s0.374-0.168,0.374-0.374S11.744,13.877,11.538,13.877z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.498,
    cy: 11.966,
    r: 0.424,
    fill: "#fdd835"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M14.498,12.44c-0.262,0-0.474-0.213-0.474-0.475s0.212-0.474,0.474-0.474s0.474,0.212,0.474,0.474 S14.76,12.44,14.498,12.44z M14.498,11.592c-0.206,0-0.374,0.168-0.374,0.374c0,0.207,0.168,0.375,0.374,0.375 s0.374-0.168,0.374-0.375C14.872,11.76,14.704,11.592,14.498,11.592z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 13.667,
    cy: 12.001,
    r: 0.424,
    fill: "#fdd835"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M13.667,12.475c-0.262,0-0.474-0.212-0.474-0.474s0.212-0.474,0.474-0.474 s0.475,0.212,0.475,0.474S13.929,12.475,13.667,12.475z M13.667,11.627c-0.206,0-0.374,0.168-0.374,0.374 s0.168,0.374,0.374,0.374c0.207,0,0.375-0.168,0.375-0.374S13.874,11.627,13.667,11.627z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 17.77,
    cy: 12.555,
    r: 0.424,
    fill: "#fdd835"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M17.77,13.028c-0.262,0-0.474-0.212-0.474-0.474s0.212-0.474,0.474-0.474s0.474,0.212,0.474,0.474 S18.031,13.028,17.77,13.028z M17.77,12.181c-0.206,0-0.374,0.168-0.374,0.374s0.168,0.374,0.374,0.374s0.374-0.168,0.374-0.374 S17.976,12.181,17.77,12.181z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 16.939,
    cy: 12.364,
    r: 0.424,
    fill: "#fdd835"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M16.938,12.838c-0.262,0-0.474-0.212-0.474-0.474s0.212-0.474,0.474-0.474 s0.474,0.212,0.474,0.474S17.2,12.838,16.938,12.838z M16.938,11.99c-0.206,0-0.374,0.168-0.374,0.374s0.168,0.374,0.374,0.374 s0.374-0.168,0.374-0.374S17.145,11.99,16.938,11.99z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 15.294,
    cy: 12.035,
    r: 0.424,
    fill: "#fdd835"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M15.294,12.51c-0.262,0-0.474-0.213-0.474-0.475s0.212-0.474,0.474-0.474s0.475,0.212,0.475,0.474 S15.556,12.51,15.294,12.51z M15.294,11.661c-0.206,0-0.374,0.168-0.374,0.374c0,0.207,0.168,0.375,0.374,0.375 c0.207,0,0.375-0.168,0.375-0.375C15.669,11.829,15.501,11.661,15.294,11.661z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 11.504,
    cy: 15.013,
    r: 0.424,
    fill: "#fdd835"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M11.504,15.486c-0.262,0-0.475-0.212-0.475-0.474s0.213-0.474,0.475-0.474 s0.474,0.212,0.474,0.474S11.766,15.486,11.504,15.486z M11.504,14.639c-0.207,0-0.375,0.168-0.375,0.374 s0.168,0.374,0.375,0.374c0.206,0,0.374-0.168,0.374-0.374S11.71,14.639,11.504,14.639z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 12.888,
    cy: 12.217,
    r: 0.424,
    fill: "#fdd835"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M12.889,12.691c-0.262,0-0.475-0.213-0.475-0.475s0.213-0.474,0.475-0.474 s0.474,0.212,0.474,0.474S13.15,12.691,12.889,12.691z M12.889,11.843c-0.207,0-0.375,0.168-0.375,0.374 c0,0.207,0.168,0.375,0.375,0.375c0.206,0,0.374-0.168,0.374-0.375C13.263,12.011,13.095,11.843,12.889,11.843z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 16.142,
    cy: 12.2,
    r: 0.424,
    fill: "#fdd835"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M16.143,12.674c-0.262,0-0.474-0.212-0.474-0.474s0.212-0.475,0.474-0.475 s0.474,0.213,0.474,0.475S16.404,12.674,16.143,12.674z M16.143,11.825c-0.206,0-0.374,0.168-0.374,0.375 c0,0.206,0.168,0.374,0.374,0.374s0.374-0.168,0.374-0.374C16.517,11.993,16.349,11.825,16.143,11.825z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fdd835",
    d: "M18.28,13.481c0,0,4.962-1.5,6-0.462c1.039,1.039-0.323,5.216-0.323,5.216l-5.331,0.162 L18.28,13.481z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M18.579,18.448L18.576,18.4l-0.349-4.956l0.038-0.012c0.204-0.062,5.005-1.498,6.05-0.448 c1.049,1.048-0.254,5.095-0.31,5.267l-0.011,0.033l-0.035,0.001L18.579,18.448z M18.333,13.517l0.34,4.828l5.248-0.158 c0.125-0.396,1.281-4.175,0.324-5.132C23.287,12.097,18.796,13.382,18.333,13.517z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.1,
    height: 5.101,
    x: 19.979,
    y: 12.81,
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.1,
    height: 5.101,
    x: 19.588,
    y: 12.81,
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.1,
    height: 4.274,
    x: 23.897,
    y: 13.097,
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.1,
    height: 5.101,
    x: 23.498,
    y: 12.81,
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.1,
    height: 5.101,
    x: 23.106,
    y: 12.81,
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.1,
    height: 5.101,
    x: 22.716,
    y: 12.81,
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.1,
    height: 5.101,
    x: 22.325,
    y: 12.81,
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.1,
    height: 5.101,
    x: 21.934,
    y: 12.81,
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.1,
    height: 5.101,
    x: 21.543,
    y: 12.81,
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.1,
    height: 5.101,
    x: 21.151,
    y: 12.81,
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.1,
    height: 5.101,
    x: 20.761,
    y: 12.81,
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.1,
    height: 5.101,
    x: 20.37,
    y: 12.81,
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fdd835",
    d: "M19.18,13.665c0,0,3.323-1.246,4.708-0.462c1.385,0.785-0.162,4.039-0.162,4.039l1.062-0.369 c0,0,1.168-3.017-0.646-4.154c-1.546-0.969-5.077,0.438-5.077,0.438L19.18,13.665z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M23.63,17.329l0.052-0.108c0.015-0.032,1.511-3.221,0.183-3.973 c-1.349-0.763-4.633,0.451-4.666,0.464l-0.054,0.02l-0.139-0.604l0.04-0.017c0.146-0.058,3.573-1.404,5.123-0.434 c1.827,1.146,0.678,4.184,0.666,4.214l-0.009,0.022l-0.021,0.007L23.63,17.329z M22.624,12.893c0.492,0,0.946,0.073,1.289,0.268 c1.282,0.727,0.168,3.414-0.092,3.996l0.928-0.322c0.099-0.271,1.045-3.02-0.633-4.073c-1.422-0.889-4.601,0.277-4.993,0.428 l0.094,0.41C19.548,13.479,21.236,12.893,22.624,12.893z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.472,
    cy: 15.878,
    r: 0.424,
    fill: "#fdd835"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M25.472,16.352c-0.262,0-0.474-0.212-0.474-0.474s0.212-0.474,0.474-0.474 s0.475,0.212,0.475,0.474S25.733,16.352,25.472,16.352z M25.472,15.504c-0.206,0-0.374,0.168-0.374,0.374 s0.168,0.374,0.374,0.374c0.207,0,0.375-0.168,0.375-0.374S25.679,15.504,25.472,15.504z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.814,
    cy: 12.719,
    r: 0.424,
    fill: "#fdd835"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M24.814,13.193c-0.262,0-0.474-0.213-0.474-0.475s0.212-0.474,0.474-0.474 s0.474,0.212,0.474,0.474S25.076,13.193,24.814,13.193z M24.814,12.345c-0.206,0-0.374,0.168-0.374,0.374 c0,0.207,0.168,0.375,0.374,0.375s0.374-0.168,0.374-0.375C25.188,12.513,25.021,12.345,24.814,12.345z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.316,
    cy: 13.437,
    r: 0.424,
    fill: "#fdd835"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M25.316,13.911c-0.262,0-0.474-0.212-0.474-0.474s0.212-0.474,0.474-0.474 s0.474,0.212,0.474,0.474S25.578,13.911,25.316,13.911z M25.316,13.063c-0.206,0-0.374,0.168-0.374,0.374 s0.168,0.374,0.374,0.374s0.374-0.168,0.374-0.374S25.522,13.063,25.316,13.063z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.541,
    cy: 14.251,
    r: 0.424,
    fill: "#fdd835"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M25.541,14.725c-0.262,0-0.474-0.212-0.474-0.474s0.212-0.474,0.474-0.474 s0.475,0.212,0.475,0.474S25.803,14.725,25.541,14.725z M25.541,13.877c-0.206,0-0.374,0.168-0.374,0.374 s0.168,0.374,0.374,0.374c0.207,0,0.375-0.168,0.375-0.374S25.748,13.877,25.541,13.877z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.581,
    cy: 11.966,
    r: 0.424,
    fill: "#fdd835"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M22.581,12.44c-0.262,0-0.474-0.213-0.474-0.475s0.212-0.474,0.474-0.474s0.475,0.212,0.475,0.474 S22.843,12.44,22.581,12.44z M22.581,11.592c-0.206,0-0.374,0.168-0.374,0.374c0,0.207,0.168,0.375,0.374,0.375 c0.207,0,0.375-0.168,0.375-0.375C22.956,11.76,22.788,11.592,22.581,11.592z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 23.412,
    cy: 12.001,
    r: 0.424,
    fill: "#fdd835"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M23.412,12.475c-0.262,0-0.474-0.212-0.474-0.474s0.212-0.474,0.474-0.474 s0.474,0.212,0.474,0.474S23.674,12.475,23.412,12.475z M23.412,11.627c-0.206,0-0.374,0.168-0.374,0.374 s0.168,0.374,0.374,0.374s0.374-0.168,0.374-0.374S23.618,11.627,23.412,11.627z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 19.31,
    cy: 12.555,
    r: 0.424,
    fill: "#fdd835"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M19.31,13.028c-0.262,0-0.474-0.212-0.474-0.474s0.212-0.474,0.474-0.474s0.475,0.212,0.475,0.474 S19.571,13.028,19.31,13.028z M19.31,12.181c-0.206,0-0.374,0.168-0.374,0.374s0.168,0.374,0.374,0.374 c0.207,0,0.375-0.168,0.375-0.374S19.517,12.181,19.31,12.181z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 20.141,
    cy: 12.364,
    r: 0.424,
    fill: "#fdd835"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M20.141,12.838c-0.262,0-0.474-0.212-0.474-0.474s0.212-0.474,0.474-0.474 s0.474,0.212,0.474,0.474S20.402,12.838,20.141,12.838z M20.141,11.99c-0.206,0-0.374,0.168-0.374,0.374s0.168,0.374,0.374,0.374 s0.374-0.168,0.374-0.374S20.347,11.99,20.141,11.99z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 21.785,
    cy: 12.035,
    r: 0.424,
    fill: "#fdd835"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M21.785,12.51c-0.262,0-0.474-0.213-0.474-0.475s0.212-0.474,0.474-0.474s0.474,0.212,0.474,0.474 S22.047,12.51,21.785,12.51z M21.785,11.661c-0.206,0-0.374,0.168-0.374,0.374c0,0.207,0.168,0.375,0.374,0.375 s0.374-0.168,0.374-0.375C22.159,11.829,21.991,11.661,21.785,11.661z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 25.576,
    cy: 15.013,
    r: 0.424,
    fill: "#fdd835"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M25.576,15.486c-0.262,0-0.475-0.212-0.475-0.474s0.213-0.474,0.475-0.474 s0.474,0.212,0.474,0.474S25.838,15.486,25.576,15.486z M25.576,14.639c-0.207,0-0.375,0.168-0.375,0.374 s0.168,0.374,0.375,0.374c0.206,0,0.374-0.168,0.374-0.374S25.782,14.639,25.576,14.639z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 24.191,
    cy: 12.217,
    r: 0.424,
    fill: "#fdd835"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M24.191,12.691c-0.262,0-0.474-0.213-0.474-0.475s0.212-0.474,0.474-0.474 s0.474,0.212,0.474,0.474S24.453,12.691,24.191,12.691z M24.191,11.843c-0.206,0-0.374,0.168-0.374,0.374 c0,0.207,0.168,0.375,0.374,0.375s0.374-0.168,0.374-0.375C24.565,12.011,24.397,11.843,24.191,11.843z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 20.937,
    cy: 12.2,
    r: 0.424,
    fill: "#fdd835"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M20.938,12.674c-0.262,0-0.475-0.212-0.475-0.474s0.213-0.475,0.475-0.475 s0.474,0.213,0.474,0.475S21.199,12.674,20.938,12.674z M20.938,11.825c-0.207,0-0.375,0.168-0.375,0.375 c0,0.206,0.168,0.374,0.375,0.374c0.206,0,0.374-0.168,0.374-0.374C21.312,11.993,21.144,11.825,20.938,11.825z"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#fdd835",
    points: "18.561,8 18.132,8.783 18.52,9.51 18.956,8.783"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M18.517,9.611l-0.441-0.829l0.013-0.024l0.476-0.865l0.449,0.892l-0.014,0.023L18.517,9.611z M18.188,8.782l0.334,0.626l0.377-0.628l-0.34-0.673L18.188,8.782z"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#fdd835",
    points: "18.561,9.891 18.132,10.674 18.52,11.401 18.956,10.674"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M18.517,11.502l-0.441-0.828l0.013-0.024l0.476-0.866l0.449,0.893l-0.014,0.023L18.517,11.502z M18.188,10.674l0.334,0.625l0.377-0.627l-0.34-0.674L18.188,10.674z"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#fdd835",
    points: "20.023,9.718 19.355,9.288 18.734,9.676 19.355,10.112"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M19.353,10.172l-0.709-0.499l0.064-0.039l0.646-0.405l0.764,0.491L19.353,10.172z M18.825,9.679 l0.531,0.374l0.57-0.337l-0.572-0.368L18.825,9.679z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#fdd835",
    points: "18.353,9.718 17.725,9.288 17.141,9.676 17.725,10.112"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M17.722,10.173l-0.667-0.499l0.67-0.446l0.72,0.492L17.722,10.173z M17.229,9.678l0.499,0.374 l0.535-0.336l-0.538-0.367L17.229,9.678z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 18.56,
    cy: 9.727,
    r: 0.368,
    fill: "#fdd835"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M18.56,10.146c-0.23,0-0.418-0.188-0.418-0.418S18.329,9.31,18.56,9.31 c0.231,0,0.419,0.188,0.419,0.418S18.791,10.146,18.56,10.146z M18.56,9.409c-0.176,0-0.318,0.143-0.318,0.318 s0.143,0.318,0.318,0.318s0.319-0.143,0.319-0.318S18.735,9.409,18.56,9.409z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fdd835",
    d: "M17.784,13.042c0,0-0.115,2.862-0.6,3.646c1.823,0.185,2.677,0.023,2.677,0.023 s-0.577-2.654-0.623-3.67C18.822,13.111,17.784,13.042,17.784,13.042z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M18.79,16.826c-0.415,0-0.95-0.021-1.611-0.088l-0.08-0.008l0.042-0.068 c0.474-0.764,0.593-3.594,0.594-3.622l0.002-0.052l0.051,0.004c0.011,0,1.035,0.071,1.443,0l0.056-0.009l0.002,0.057 c0.045,1,0.616,3.635,0.622,3.661l0.011,0.051l-0.051,0.009C19.865,16.762,19.511,16.826,18.79,16.826z M17.265,16.646 c1.503,0.146,2.331,0.053,2.537,0.024c-0.079-0.369-0.553-2.608-0.61-3.571c-0.391,0.05-1.152,0.01-1.359-0.005 C17.814,13.484,17.69,15.835,17.265,16.646z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M18.166,13.042c0,0-0.056,2.862-0.29,3.646c0.88,0.185,1.292,0.023,1.292,0.023 s-0.279-2.654-0.301-3.67C18.667,13.111,18.166,13.042,18.166,13.042z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M18.656,16.827c-0.203,0-0.465-0.021-0.791-0.09l-0.053-0.011l0.016-0.053 c0.229-0.769,0.287-3.604,0.288-3.633l0.001-0.057l0.056,0.008c0.005,0.001,0.492,0.064,0.679,0.003l0.065-0.022l0.001,0.068 c0.021,1.002,0.298,3.639,0.301,3.666l0.004,0.037l-0.035,0.015C19.176,16.763,19.005,16.827,18.656,16.827z M17.938,16.65 c0.68,0.134,1.062,0.057,1.177,0.026c-0.035-0.333-0.267-2.596-0.296-3.571c-0.185,0.035-0.481,0.006-0.604-0.007 C18.206,13.503,18.146,15.861,17.938,16.65z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 18.531,
    cy: 14.52,
    r: 0.355,
    fill: "#fdd835"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M18.531,14.924c-0.223,0-0.404-0.182-0.404-0.404s0.182-0.404,0.404-0.404s0.404,0.182,0.404,0.404 S18.754,14.924,18.531,14.924z M18.531,14.215c-0.168,0-0.305,0.137-0.305,0.305s0.137,0.305,0.305,0.305s0.305-0.137,0.305-0.305 S18.699,14.215,18.531,14.215z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 18.531,
    cy: 13.903,
    r: 0.292,
    fill: "#fdd835"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M18.531,14.245c-0.188,0-0.342-0.153-0.342-0.343c0-0.188,0.153-0.342,0.342-0.342 s0.342,0.153,0.342,0.342C18.873,14.092,18.72,14.245,18.531,14.245z M18.531,13.66c-0.134,0-0.242,0.108-0.242,0.242 s0.108,0.243,0.242,0.243s0.242-0.109,0.242-0.243S18.665,13.66,18.531,13.66z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 18.531,
    cy: 13.364,
    r: 0.24,
    fill: "#fdd835"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M18.531,13.654c-0.16,0-0.29-0.13-0.29-0.29s0.13-0.29,0.29-0.29s0.29,0.13,0.29,0.29 S18.691,13.654,18.531,13.654z M18.531,13.174c-0.104,0-0.19,0.086-0.19,0.19s0.086,0.19,0.19,0.19s0.19-0.086,0.19-0.19 S18.636,13.174,18.531,13.174z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 18.531,
    cy: 15.281,
    r: 0.424,
    fill: "#fdd835"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M18.531,15.755c-0.262,0-0.474-0.212-0.474-0.474s0.212-0.475,0.474-0.475s0.474,0.213,0.474,0.475 S18.793,15.755,18.531,15.755z M18.531,14.906c-0.206,0-0.374,0.168-0.374,0.375c0,0.206,0.168,0.374,0.374,0.374 s0.374-0.168,0.374-0.374C18.905,15.074,18.737,14.906,18.531,14.906z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 18.531,
    cy: 12.754,
    r: 0.424,
    fill: "#fdd835"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M18.531,13.228c-0.262,0-0.474-0.212-0.474-0.474s0.212-0.474,0.474-0.474s0.474,0.212,0.474,0.474 S18.793,13.228,18.531,13.228z M18.531,12.38c-0.206,0-0.374,0.168-0.374,0.374s0.168,0.374,0.374,0.374s0.374-0.168,0.374-0.374 S18.737,12.38,18.531,12.38z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 18.531,
    cy: 11.629,
    r: 0.762,
    fill: "#fdd835"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M18.531,12.44c-0.447,0-0.812-0.364-0.812-0.812s0.364-0.812,0.812-0.812s0.812,0.364,0.812,0.812 S18.979,12.44,18.531,12.44z M18.531,10.917c-0.393,0-0.712,0.319-0.712,0.712s0.319,0.712,0.712,0.712s0.712-0.319,0.712-0.712 S18.924,10.917,18.531,10.917z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fdd835",
    d: "M12.937,20.589c0,0-1.292-3.3-2.031-3.854c1.408-0.992,2.423-0.115,2.769,0.715 c0.046-1.569,1.177-2.885,3.093-0.254c0.231-1.662,2.954-2.216,3.416,0.069c0,0,2.562-3.37,3.093,0.162 c0.669-1.339,1.939-1.362,2.723-0.692c-0.6,0.6-1.315,2.146-1.916,3.808C22.538,20.543,12.937,20.589,12.937,20.589z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M12.903,20.639l-0.013-0.031c-0.013-0.033-1.296-3.293-2.015-3.833l-0.055-0.041l0.057-0.04 c0.581-0.409,1.14-0.539,1.662-0.391c0.451,0.131,0.851,0.479,1.098,0.948c0.069-0.808,0.417-1.412,0.912-1.565 c0.428-0.132,1.155,0.005,2.189,1.387c0.184-0.865,1.013-1.354,1.734-1.376c0.018,0,0.035-0.001,0.053-0.001 c0.662,0,1.426,0.383,1.685,1.457c0.275-0.343,1.342-1.583,2.189-1.362c0.445,0.114,0.748,0.612,0.901,1.482 c0.385-0.681,0.886-0.913,1.248-0.986c0.515-0.107,1.055,0.045,1.482,0.41l0.041,0.035l-0.038,0.038 c-0.532,0.534-1.227,1.915-1.904,3.79l-0.012,0.033h-0.035c-1.528,0-11.05,0.046-11.146,0.046H12.903z M10.989,16.738 c0.715,0.633,1.843,3.447,1.982,3.801c0.627-0.003,9.494-0.046,11.077-0.046c0.663-1.828,1.344-3.188,1.878-3.755 c-0.398-0.319-0.894-0.451-1.356-0.354c-0.363,0.073-0.875,0.318-1.249,1.065l-0.071,0.142l-0.023-0.156 c-0.138-0.918-0.424-1.438-0.851-1.548c-0.059-0.015-0.119-0.021-0.181-0.021c-0.872,0-1.959,1.415-1.971,1.431l-0.067,0.088 l-0.021-0.108c-0.188-0.931-0.785-1.479-1.602-1.479c-0.02,0-0.038,0-0.058,0c-0.712,0.022-1.536,0.522-1.658,1.407l-0.018,0.123 l-0.072-0.101c-0.81-1.111-1.575-1.621-2.149-1.444c-0.493,0.152-0.828,0.809-0.854,1.67l-0.007,0.233L13.63,17.47 c-0.222-0.532-0.64-0.933-1.118-1.071C12.043,16.263,11.526,16.374,10.989,16.738z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.534,
    cy: 20.531,
    fill: "#231f20",
    rx: 5.574,
    ry: 0.727
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M18.534,21.309c-2.726,0-5.623-0.272-5.623-0.777s2.897-0.776,5.623-0.776 s5.623,0.271,5.623,0.776S21.26,21.309,18.534,21.309z M18.534,19.854c-3.255,0-5.523,0.356-5.523,0.677s2.269,0.678,5.523,0.678 s5.523-0.357,5.523-0.678S21.789,19.854,18.534,19.854z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M12.472,17.536c0,0,0.226,0.365,0.295,0.66c-0.2,0.017-0.582-0.13-0.582-0.13 s1.051,0.73,1.321,1.269c-0.209-0.704-0.078-1.625-0.078-1.625l-0.243,0.4C13.184,18.11,12.646,17.554,12.472,17.536z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M14.992,16.824l0.182,0.834l-0.521-0.139c0,0,0.799,0.739,1.008,1.434 c-0.061-0.895,0.104-1.712,0.104-1.712l-0.321,0.269L14.992,16.824z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M18.502,16.65c0,0-0.07,0.565-0.278,0.634c-0.209,0.07-0.547-0.243-0.547-0.243 s0.712,1.112,0.817,1.972c0.104-0.86,0.834-1.972,0.834-1.972s-0.339,0.33-0.573,0.235C18.519,17.18,18.502,16.65,18.502,16.65z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M21.995,16.754c0,0-0.295,0.704-0.443,0.73s-0.313-0.235-0.313-0.235s0.2,1.147,0.078,1.703 c0.348-0.86,1.069-1.451,1.069-1.451s-0.356,0.182-0.46,0.13C21.821,17.58,21.995,16.754,21.995,16.754z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M24.54,17.502c0,0-0.556,0.634-0.678,0.626s-0.269-0.4-0.269-0.4s0.07,1.13-0.078,1.581 c0.443-0.712,1.286-1.242,1.286-1.242s-0.434,0.252-0.547,0.165S24.54,17.502,24.54,17.502z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8LiechtensteinCircular);
export default __webpack_public_path__ + "static/media/icons8-liechtenstein-circular.79984067de1bd910e50bab0c72c14e1a.svg";
export { ForwardRef as ReactComponent };